import { useQuery } from '@apollo/client';
import { PortfolioInstitution } from '@bakerweb/models';
import { GET_INSTITUTION } from '../graphql/queries/getInstitution';

export const useGetInstitution = (institutionId: string | null | undefined) => {
  const { data, loading, error } = useQuery<{ institutions: PortfolioInstitution[] }>(GET_INSTITUTION, {
    variables: { institutionId },
    skip: !institutionId,
    fetchPolicy: 'cache-first'
  });

  return {
    loading,
    error,
    institution: data?.institutions?.[0] ?? null
  };
};
